import { render, staticRenderFns } from "./test_lazy_scroller.vue?vue&type=template&id=0b58b26a&"
import script from "./test_lazy_scroller.vue?vue&type=script&lang=js&"
export * from "./test_lazy_scroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports